import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { WebsiteCard } from '../../components/Card/Card'
import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'
import { getBrowserExtensionWorkflowsSteps } from './data'

export function SectionBrowserExtensionWorkflowSteps() {
  const intl = useIntl()
  const stepsData = getBrowserExtensionWorkflowsSteps(intl)

  return (
    <Section containerVerticalPadding={120} background="moon-dust-lighter">
      <WebsiteText
        variant="title"
        className="margin-bottom-40 text-align-center"
      >
        <FormattedMessage
          id="browserExtension.steps.title"
          defaultMessage="Trigger workflows with one click"
        />
      </WebsiteText>
      <div className="grid-12 grid-gap-24">
        {stepsData.map(({ title, desc, illustration }, index) => (
          <WebsiteCard
            key={index}
            hoverOutline={false}
            className={classNames(
              index === 0 && 'grid-span-6 flexbox flexbox-column',
              index === 1 && 'grid-span-6 flexbox flexbox-column',
              ![0, 1].includes(index) &&
                'grid-span-12 flexbox flexbox-column-reverse-small',
              'grid-span-12-small radius-large overflow-hidden border-small border-alpha-shade-40'
            )}
          >
            <div className="padding-top-40 padding-horizontal-40 padding-bottom-40">
              <div
                className={classNames(
                  'font-size-3 font-family-title font-weight-medium line-height-title margin-bottom-12',
                  index === stepsData.length - 1 &&
                    'padding-top-32 padding-top-0-small'
                )}
              >
                {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
                <span className="saturn-orange">{index + 1}. </span>
                {title}
              </div>
              <div className="font-size-5 shade-10">{desc}</div>
            </div>
            {illustration}
          </WebsiteCard>
        ))}
      </div>
    </Section>
  )
}
